<template>
    <section class="app">
        <section class="header">
            <div>
                <img src="../../assets/imgs/logo-porto-seco.jpg" height="50">
            </div>
            <div></div>
        </section>
        <section class="body">
            <section class="message">
                <div class="title">
                    <h1>{{title}}</h1>
                </div>
                <div class="box">
                    <div class="text">{{text}}</div>
                    <div class="control">
                        <router-link :to="url"> <i class="fal fa-long-arrow-left"></i> &nbsp; {{btnText}}</router-link>
                    </div>
                </div>
            </section>
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg" height="20">
            </div>
        </section>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                title: '',
                text: '',
                btnText: '',
                url: 'login',
            }
        },
        created(){
            this.title = this.$route.params.title || ''
            this.text = this.$route.params.text || ''
            this.btnText = this.$route.params.btnText || ''
            this.url = this.$route.params.url || ''

            

            if(!this.title){
                this.$router.push({
                    name: 'login',
                })
            }
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
